var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-dashboard',{attrs:{"autoRefresh":false,"tableStats":_vm.stats,"graphStats":_vm.stats,"statBarStats":_vm.statBarStats,"statBarSubStats":_vm.statsBarSubStats,"table-fields":['exchange_name']}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479051e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/demand/pages/Dashboard.vue
// module id = null
// module chunks = 